import React from "react";
import { Card, Avatar, Typography, Space, Row, Col, Divider, Badge, Flex } from "antd";
import { MailOutlined, PhoneOutlined, EnvironmentOutlined } from "@ant-design/icons";
import ProfileAvatar from "./ProfileAvtar";

const { Text, Title } = Typography;

interface ProfileCardProps {
    name: string;
    jobTitle: string;
    location: string;
    email: string;
    phone: string;
    empId: string;
    businessUnit: string;
    reportingTo: string;
    workMode: string;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
    name,
    jobTitle,
    location,
    email,
    phone,
    empId,
    businessUnit,
    reportingTo,
    workMode,
}) => {
    return (
        <Card
            style={{ margin: "0 auto", borderRadius: 10 }}
            bodyStyle={{ padding: 24 }}
            cover={
                <div
                    style={{
                        background: `url(https://via.placeholder.com/800x200) no-repeat center/cover`,
                        height: 150,
                    }}
                />
            }
        >
            <Row style={{ marginTop: -100 }}>
                <Col span={24}>
                    <Flex justify="start">
                        <ProfileAvatar />
                        <div style={{ marginTop: 20, marginLeft: 10 }}>
                            <Space direction="vertical" align="start" size={0}>
                                <Space direction="horizontal" size={0}>
                                    <Title level={5} style={{ margin: 0, lineHeight: 1 }}>
                                        {name}{" "}
                                        <Badge
                                            count={workMode}
                                            style={{
                                                backgroundColor: "#52c41a",
                                                fontWeight: "bold",
                                            }}
                                        />
                                    </Title>
                                </Space>
                                <Text type="secondary" style={{ margin: 0, lineHeight: 1 }}>{jobTitle}</Text>
                            </Space>
                            <Row style={{ marginTop: 25 }} gutter={[20, 20]}>
                                <Col span={24}>
                                    <Space direction="horizontal" size={[20, 20]}>
                                        <Text>
                                            <EnvironmentOutlined /> {location}
                                        </Text>
                                        <Text>
                                            <MailOutlined /> {email}
                                        </Text>
                                        <Text>
                                            <PhoneOutlined /> {phone}
                                        </Text>
                                    </Space>
                                </Col>
                                <Col span={24}>
                                    <Space direction="horizontal" size={[20, 20]}>
                                        <Space direction="vertical" size={[0, 0]}>
                                            <Text strong>Job Title</Text>
                                            <Text>{jobTitle}</Text>
                                        </Space>
                                        <Space direction="vertical" size={[0, 0]}>
                                            <Text strong>Emp. ID</Text>
                                            <Text>{empId}</Text>
                                        </Space>
                                        <Space direction="vertical" size={[0, 0]}>
                                            <Text strong>Business Unit</Text>
                                            <Text>{businessUnit}</Text>
                                        </Space>
                                        {reportingTo && <Space direction="vertical" size={[0, 0]}>
                                            <Text strong>Reporting To</Text>
                                            <Text>{reportingTo}</Text>
                                        </Space>}
                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    </Flex>
                </Col>
            </Row>
        </Card>
    );
};

export default ProfileCard;
